// reducers/identity.js
import { v4 as uuidv4 } from "uuid";

const initialUID = uuidv4();

const INITIAL_STATE = {
    uid: initialUID,
    appUID: null,
    origin: null,
};

// types
export const IDENTITY_SET_APP_UID = "IDENTITY_SET_APP_UID";
export const IDENTITY_SET_DEVICE_UID = "IDENTITY_SET_DEVICE_UID";
export const IDENTITY_SET_ORIGIN = "IDENTITY_SET_ORIGIN";

// actions
export const setAppUID = (appUID) => ({ type: IDENTITY_SET_APP_UID, payload: appUID });
export const setDeviceUID = (uid) => ({ type: IDENTITY_SET_DEVICE_UID, payload: uid });
export const setIdentityOrigin = (origin) => ({ type: IDENTITY_SET_ORIGIN, payload: origin });

// reducer
export default function reducerIdentity(state = INITIAL_STATE, action) {
    switch (action.type) {
        case IDENTITY_SET_APP_UID:
            return { ...state, appUID: action.payload };
        case IDENTITY_SET_DEVICE_UID:
            return { ...state, uid: action.payload };
        case IDENTITY_SET_ORIGIN:
            return { ...state, origin: action.payload };
        default:
            return state;
    }
}
